module.exports = __webpack_public_path__ + "img/bg-product-2.d8a35459.png";